document.addEventListener("DOMContentLoaded", (event) => {
  class QuickView extends HTMLElement{
    constructor(){
      super();
      this.productHandle = this.getAttribute('data-product-handle');
      this.quickviewModal = document.querySelector('[data-quickview-modal]')
      this.addEventListener('click',this.initPopup);
      window.quickViewslider = null
    }
  
    initPopup(){
      this.quickviewModal.querySelector('#quickvieRender').innerHTML = '';
      this.getProductsection(this.productHandle,'quickview-product');
      this.quickviewModal.classList.add('open');
      
      
    }
    initSlider(){
       window.quickViewslider  = new Flickity( this.sliderContainer, {
        cellAlign: 'center',
        contain: false,
        pageDots: false
      });

    }
    getProductsection(handle,sectionid){
      fetch(`/products/${handle}?section_id=${sectionid}`)
      .then(res => {
        return res.text();
      })
      .then((data)=>{
        const duplicateElement = document.createElement('div');
        duplicateElement.innerHTML = data;
        this.quickviewModal.querySelector('#quickvieRender').innerHTML = duplicateElement.querySelector('.qw-product-row').parentNode.innerHTML;
        this.sliderContainer = this.quickviewModal.querySelector('.qw-product-slider')
        this.initSlider()
        setTimeout(function(){
          window.quickViewslider.resize()  
        },100);
        
      })
    }
  }
  customElements.define("quick-view",QuickView);
    document.querySelector('[data-quick-close]').addEventListener('click',function(){
    document.querySelector('[data-quickview-modal]').classList.remove('open');
  });
});

class VariantButtons extends HTMLElement{
  constructor(){
    super()
    this.container = this
    this.options = this.querySelectorAll('.qw-option-variant');
    this.pricelist = JSON.parse(this.querySelector('#qw-variant-price').textContent);
    this.butNowButton = document.querySelector('[data-buynow]')
    this.addEventListener('change',this.onVariantChange);
    this.init()  
  }
  init(){
    setTimeout(function(){
      this.dispatchEvent(new Event('change'));  
    }.bind(this),250);
  }
  onVariantChange(){
    this.updateOptions()
    
    let variant = this.currentVariant;
    if(!variant){
      return ;
    }
    this.renderPrice(variant);
    this.updateOuterElement(variant);
    this.updateAddbutton(variant);
    this.updateVariant(variant)
    this.updateMedia(variant)
  }
  updateOptions(){
    let selctedOption = new Array()
    Array.from(this.options).forEach((item)=>{
      selctedOption.push(item.querySelector(':checked').value)
    })
    this.currentVariant = this.getVariantData().filter((item)=>{
      return item.title == selctedOption.join(' / ');
    })[0];
  }
  getCurrentPrice(){
    const price_object = this.pricelist.filter((item)=>{
      let compare_price_var = this.currentVariant.id.toString();
      return item.id == compare_price_var
    })[0];
    
    return price_object
  }
  renderPrice(variant){
    if(variant.compare_at_price > variant.price){
      document.querySelector('[data-reg-price]').classList.add('qw-sale-price');
      document.querySelector('[data-reg-price]').innerHTML = this.getCurrentPrice().reg_price;
      document.querySelector('[data-compare-price]').classList.remove('hide');
      document.querySelector('[data-compare-price]').innerHTML = this.getCurrentPrice().compare_price;
    }else{
      document.querySelector('[data-reg-price]').classList.remove('qw-sale-price');
      document.querySelector('[data-reg-price]').innerHTML = this.getCurrentPrice().reg_price;
      document.querySelector('[data-compare-price]').classList.add('hide');
      document.querySelector('[data-compare-price]').innerHTML = this.getCurrentPrice().compare_price;
    }
  }
  updateAddbutton(variant){
    let form = document.querySelector('product-submit');
    if(variant.available){
      form.querySelector('.submitProduct').removeAttribute('disabled')
      form.querySelector('.qw-form-submit').innerHTML = 'Add To Cart'
      if(this.butNowButton){
        this.butNowButton.removeAttribute('disabled')
        this.butNowButton.setAttribute('data-variantid',variant.id);
      }
    }
    else{
      form.querySelector('.submitProduct').setAttribute('disabled','disabled');
      form.querySelector('.qw-form-submit').innerHTML = 'soldOut';
      if(this.butNowButton){
        this.butNowButton.setAttribute('disabled','disabled');
        this.butNowButton.setAttribute('data-variantid',variant.id);
      }
    }
  }
  updateVariant(){
      const variantData = this.getVariantData();
    let optionOneSelectedValue = this.options[0].querySelector(':checked').value
    let option1Variant = variantData.filter((variant)=>(variant.option1 == optionOneSelectedValue))
    if(this.options.length == 1){
      let unavailableFirstData = variantData.filter((variant)=>(variant.available == false));
      unavailableFirstData.forEach((item)=>{
        this.options[0].querySelector('[value="'+item.title+'"]').classList.add('disabled');
      })
     // this.options[0].querySelector('[value="'+unavailableFirstData.title+'"]').classList.add('disabled');
    }
    this.options.forEach((option,index)=>{
      if(index == 0) return;
      
      const previousSelectedValue = this.options[index - 1].querySelector(':checked').value;
      let availableVariants = option1Variant.filter((variant)=>{
          if(variant[`option${index}`] == previousSelectedValue && variant.available){
            return true;
          }
        
      });
      let availableOptions = new Array();
      availableVariants.forEach((variant)=>{
        availableOptions.push(variant[`option${index + 1}`])
      });
      let variantInputs = this.options[index].querySelectorAll(`input`);
      variantInputs.forEach((item)=>{
        if(availableOptions.includes(item.value)){
          item.classList.remove('disabled')
        }
        else{
          item.classList.add('disabled')
        }
      });
    });
  }
  
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateMedia(variant){
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    let curretMedia = document.querySelector('.qw-image-item[data-media-id="'+variant.featured_image.id+'"]');
    if(curretMedia){
      let slideIndex = parseInt(curretMedia.getAttribute('data-media-index'));
      if(window.quickViewslider && slideIndex){
          window.quickViewslider.selectCell(slideIndex - 1)
      }
    }
  }
  
  updateOuterElement(variant){
    document.getElementById('qwVariantId').value = variant.id
  }  
}

customElements.define('variant-buttons',VariantButtons)

class QunatityBox extends HTMLElement{
  constructor(){
    super();
    this.container = this
    this.buttons = this.container.querySelectorAll('button');
    
    Array.from(this.buttons).forEach((button)=>{
      button.addEventListener('click',this.quantityChange.bind(this))
    });
  }
  quantityChange(event){
    event.preventDefault();
    const inputSelector = this.container.querySelector('input');
    let UpdatedValue = parseInt(inputSelector.value)
    if(event.target.hasAttribute('data-minus')){
      UpdatedValue = UpdatedValue - 1;
    }
    else{
      UpdatedValue = UpdatedValue + 1;
    }
    if(UpdatedValue == 0){
      return
    }
    else{
      inputSelector.value = UpdatedValue
    }
  }
}

customElements.define('quantity-box',QunatityBox)




function quicview_model_events(){
  document.querySelector('[data-quickview-modal]').addEventListener('click',function(event){
    if(event.target.classList.contains('quickViewModal')){
      event.target.classList.remove('open');
    }
  })
}
quicview_model_events();

